<div class="d-flex align-items-center flex-column">
    <div class="loading-icon"></div>
    <h4 class="loading mt-3 text-center">{{message}}</h4>
</div>
